// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__wWBDd","title":"FrontImage_title__24JJe"};